/* The mobile shortcut returns to native purchase controls; it never adds an
 * item or bypasses disclosures, variant selection, inventory or cart guards. */
if (!customElements.get('ots-mobile-purchase')) {
  customElements.define('ots-mobile-purchase', class extends HTMLElement {
    connectedCallback() {
      // Theme-editor section replacements may connect before child parsing ends.
      this.initFrame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (!this.isConnected) return;
      this.anchor = document.getElementById(`OTSPurchase-${this.dataset.sectionId}`);
      this.info = document.getElementById(`ProductInfo-${this.dataset.sectionId}`);
      if (!this.anchor || !this.info) return;
      this.update = () => {
        const nativeButton = this.info.querySelector('product-form button[name="add"]');
        const price = this.info.querySelector('[id^="price-"] .price-item--regular');
        const activePrice = this.info.querySelector('[id^="price-"] .price--on-sale .price-item--sale') || price;
        const dialogOpen = Boolean(document.querySelector('dialog[open], .drawer.active, #Details-menu-drawer-container[open]'));
        this.hidden = !matchMedia('(max-width: 749px)').matches || this.anchor.getBoundingClientRect().top >= -160 || !nativeButton || nativeButton.disabled || dialogOpen;
        document.body.classList.toggle('ots-has-sticky-purchase', !this.hidden);
        if (activePrice && this.querySelector('strong').textContent !== activePrice.textContent.trim()) this.querySelector('strong').textContent = activePrice.textContent.trim();
      };
      this.onScroll = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
      };
      this.onClick = () => { this.anchor.focus({preventScroll: true}); };
      this.querySelector('a').addEventListener('click', this.onClick);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.observer = new MutationObserver(this.onScroll);
      this.observer.observe(this.info, { subtree: true, attributes: true, attributeFilter: ['disabled','open'], childList: true });
      this.update();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      this.observer?.disconnect();
      this.querySelector('a')?.removeEventListener('click', this.onClick);
      cancelAnimationFrame(this.frame);
      document.body.classList.remove('ots-has-sticky-purchase');
    }
  });
}
